export default __webpack_public_path__ + "static/media/logo-MadgicxSm.75f87070.svg";